import classNames from "classnames";
import { FunctionComponent, ReactElement, useMemo } from "react";
import { IBarProps } from "./types";

export const Bar: FunctionComponent<IBarProps> = (
  props: IBarProps
): ReactElement<IBarProps> => {
  const { backgroundColor, color, total = 0, value = 0 } = props;

  const progress: number = useMemo(() => {
    if (0 === total) {
      return 100;
    } else if (value > total) {
      return 100;
    } else {
      return (100 * value) / total;
    }
  }, [total, value]);

  return (
    <div className="horizontalChart">
      <div
        className={classNames("horizontalChartBg")}
        style={{
          backgroundColor,
        }}
      />
      <div
        className={classNames("horizontalChartComplete")}
        style={{
          backgroundColor: color,
          width: `${progress}%`,
        }}
      />
    </div>
  );
};
